module.exports = __webpack_public_path__ + "static/media/powrot-do-przedszkola.6d07830b.jpg";